import { commonViewTexts } from '../common';
import { editDialogCommonViewTexts } from './edit-dialog-common';

const targetName = commonViewTexts.user;

export const editUserDialogViewTexts = {
  title: `${targetName} 編集`,
  description1: editDialogCommonViewTexts.description1(targetName),
  description2: editDialogCommonViewTexts.description2,
  label1: `${targetName}名`,
  label2: commonViewTexts.emailAddress,
  label3: commonViewTexts.password,
  inputHint: '空欄の場合はパスワードを変更しません',
  userIsActive: 'ログイン有効',
  cancel: editDialogCommonViewTexts.cancel,
  ok: editDialogCommonViewTexts.ok
} as const;
